import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
export interface BreadcrumbItem {
    title?: string;
    name?:string
    url?: string;
    class?: string;
    id?:string;
  }

@Injectable({
    providedIn: 'root',
})

export class CompanyService {
    private companyIdSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    companyId$: Observable<string> = this.companyIdSubject.asObservable();
    private breadcrumbSubject: BehaviorSubject<BreadcrumbItem[]> = new BehaviorSubject<BreadcrumbItem[]>(null);
    breadcrumb$: Observable<BreadcrumbItem[]> = this.breadcrumbSubject.asObservable();
    getCompanyList: any;

    setCompanyId(companyId: string) {
        this.companyIdSubject.next(companyId);
    }
    
    getCompanyId(): Observable<string> {
        return this.companyId$;
    }
    
    setAdminHeaders(companyId: string, breadcrumb: BreadcrumbItem[]) {
        this.companyIdSubject.next(companyId);
        this.breadcrumbSubject.next(breadcrumb);
    }

    getAdminHeaders(): Observable<{ companyId: string, breadcrumb: BreadcrumbItem[] }> {
        return combineLatest([this.companyId$, this.breadcrumb$]).pipe(
            map(([companyId, breadcrumb]) => ({ companyId, breadcrumb }))
        );
    }
}
